import React from 'react';
import { ArrowRightIcon, ShieldCheckIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="bg-[#0F172A] py-20 px-4 text-center relative overflow-hidden" data-id="element-131">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-132">
        <div className="absolute top-[-10%] right-[-5%] w-[400px] h-[400px] bg-green-500/10 rounded-full blur-[100px]" data-id="element-133" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[400px] h-[400px] bg-orange-500/10 rounded-full blur-[100px]" data-id="element-134" />
      </div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-135">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-136">
          Oferta por tiempo limitado.
        </h2>

        <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 mb-10 border border-white/10 inline-block w-full max-w-xl" data-id="element-137">
          <div className="flex flex-col items-center justify-center gap-2 mb-8" data-id="element-138">
            <span className="text-xl text-gray-400 line-through font-medium" data-id="element-139">
              Antes $49.990
            </span>
            <div className="flex items-baseline gap-2" data-id="element-140">
              <span className="text-5xl md:text-6xl font-extrabold text-[#4ADE80] drop-shadow-lg" data-id="element-141">
                $19.990
              </span>
              <span className="text-gray-400 font-medium" data-id="element-142">ARS</span>
            </div>
            <span className="inline-block bg-green-900/50 text-green-400 text-sm font-bold px-3 py-1 rounded-full mt-2 border border-green-500/30" data-id="element-143">
              AHORRAS $30.000
            </span>
          </div>

          <a href="https://pago.atlasdigitalhub.com/cart/42583890952290:1" className="group w-full bg-gradient-to-r from-[#F97316] to-[#EA580C] hover:from-[#EA580C] hover:to-[#C2410C] text-white font-bold py-5 px-8 rounded-xl text-xl md:text-2xl transition-all duration-300 shadow-lg hover:shadow-orange-500/30 flex items-center justify-center gap-3 hover:-translate-y-1" data-id="element-144">
            QUIERO ESTAR PREPARADO AHORA
            <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-145" />
          </a>

          <div className="mt-6 flex items-center justify-center gap-2 text-gray-400 text-sm" data-id="element-146">
            <ShieldCheckIcon className="w-4 h-4 text-green-500" data-id="element-147" />
            <p data-id="element-148">Pago 100% seguro y encriptado</p>
          </div>
        </div>

        <p className="text-gray-400 text-sm md:text-base max-w-md mx-auto" data-id="element-149">
          Acceso inmediato en formato PDF. Descarga directa tras la compra.
          Incluye todos los bonos de regalo.
        </p>
      </div>
    </section>;
}